import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const AccountIcon: FC<IconProps> = ({ fill, stroke, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} stroke={stroke} fill={fill}>
    <path d="M16,14a7,7,0,1,1,7-7A7,7,0,0,1,16,14ZM16,2a5,5,0,1,0,5,5A5,5,0,0,0,16,2Z" fill="current" />
    <path
      d="M23.94,32H8.06A4.06,4.06,0,0,1,4,27.94a12,12,0,0,1,24,0A4.06,4.06,0,0,1,23.94,32ZM16,17.94a10,10,0,0,0-10,10A2.06,2.06,0,0,0,8.06,30H23.94A2.06,2.06,0,0,0,26,27.94,10,10,0,0,0,16,17.94Z"
      fill="current"
    />
  </svg>
);
